// extracted by mini-css-extract-plugin
export default {"tos":"bC1ZQ_bC1ZQ","pdf":"oQWl2_oQWl2","mcLabel":"Fh8Hk_Fh8Hk"};